<template>
    <div class="holoverz-whitepaper-section" :class="`button-${buttonSide}`" :style="sectionVars">
        <div class="container">
            <div class="row align-items-center top-section">
                <div class="col-lg-8" :class="buttonSide === 'left' ? 'order-lg-2' : ''">
                    <div class="text-content">
                        <span class="main-text text-l" v-html="text"></span>
                    </div>
                </div>
                <div class="col-lg-4" :class="buttonSide === 'left' ? 'order-lg-1' : ''">
                    <div class="button-wrapper">
                        <base-button class="whitepaper-button" :text="buttonText" size="large" :type="buttonType"
                            @clicked="handleButtonClick()" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HoloverzWhitePaper',
    props: {
        text: {
            type: String,
            required: true,
        },
        buttonText: {
            type: String,
            required: true,
        },
        buttonLink: {
            type: String,
            required: true,
        },
        background: {
            type: String,
            default: '#0F003F',
        },
        buttonType: {
            type: String,
            default: 'light',
        },
        buttonSide: {
            type: String,
            default: 'right',
            validator: (v) => ['left', 'right'].includes(v),
        },
        // colours a `.accent` span inside the v-html text
        accentColor: {
            type: String,
            default: 'inherit',
        },
        textColor: {
            type: String,
            default: '#ffffff',
        },
        borderTop: {
            type: String,
            default: 'none',
        },
        // buttons are uppercase globally; Holoverz opts out, eBSO does not
        buttonTextTransform: {
            type: String,
            default: 'unset',
        },
    },
    components: {},
    data: () => ({}),
    created() { },
    computed: {
        sectionVars() {
            return {
                '--background': this.background,
                '--accent-color': this.accentColor,
                '--text-color': this.textColor,
                '--border-top': this.borderTop,
                '--button-text-transform': this.buttonTextTransform,
            };
        },
    },
    methods: {
        handleButtonClick() {
            window.open(this.buttonLink, '_blank');
        },
    },
};
</script>

<style lang="scss" scoped>
.holoverz-whitepaper-section {
    position: relative;
    background: var(--background);
    border-top: var(--border-top);
    padding: 56px 0;
    display: flex;
    align-items: center;
    margin: 0;

    .container {
        position: relative;
        z-index: 2;
    }

    .top-section {
        flex-wrap: nowrap;

        @media (max-width: $breakpoint-sm) {
            flex-wrap: wrap;
        }
    }

    .text-content {
        .main-text {
            color: var(--text-color);
            line-height: 24px;
            display: block;

            @media (max-width: $breakpoint-sm) {
                font-size: 16px;
                text-align: center;
            }

            &::v-deep {

                b,
                strong {
                    font-family: 'HKNova-Bold', sans-serif;
                }

                .accent {
                    color: var(--accent-color);
                }
            }
        }
    }

    &.button-left .button-wrapper {
        justify-content: flex-start;

        @media (max-width: $breakpoint-sm) {
            justify-content: center;
        }
    }

    .button-wrapper {
        display: flex;
        justify-content: flex-end;
        align-items: center;

        @media (max-width: $breakpoint-sm) {
            justify-content: center;
            margin-top: 30px;
        }

        .whitepaper-button {
            min-width: 255px;
            text-transform: var(--button-text-transform);

            &::v-deep {
                .button-label {
                    font-family: 'HKNova-Bold', sans-serif;
                    text-transform: capitalize;
                }
            }
        }
    }
}
</style>
